document.addEventListener('DOMContentLoaded', () => {
  const optionsContainer = document.querySelector('.svadezi-product-options');
  if (!optionsContainer) return;

  let variantsData = [];
  try {
    const rawAttr = optionsContainer.getAttribute('data-variants') || '[]';
    const txt = document.createElement('textarea');
    txt.innerHTML = rawAttr;
    variantsData = JSON.parse(txt.value);
  } catch (e) {
    console.error("Variants parsing error:", e);
  }
  // All our custom clickable option elements
  const allOptionElements = optionsContainer.querySelectorAll('[data-option-val]');

  allOptionElements.forEach(el => {
    // Click Listener
    el.addEventListener('click', (e) => {
      const target = e.currentTarget;
      const optionPos = target.getAttribute('data-option-pos'); // 1, 2, or 3
      const optionVal = target.getAttribute('data-option-val');

      // 1. Update UI active states and ARIA pressed states for this group
      const group = target.closest('.svadezi-option-group');
      group.querySelectorAll('[data-option-val]').forEach(node => {
        node.classList.remove('active');
        node.setAttribute('aria-pressed', 'false');
      });
      target.classList.add('active');
      target.setAttribute('aria-pressed', 'true');

      // 2. Update Label Text instantly
      const labelSpan = group.querySelector('[data-selected-label]');
      if (labelSpan) {
        labelSpan.textContent = `Selected: ${optionVal}`;
      }

      // 3. Update Hidden Inputs
      const hiddenInput = document.getElementById(`hidden-opt-${optionPos}`);
      if (hiddenInput) {
        hiddenInput.value = optionVal;
      }
      
      // Update Native Shopify <product-form> options to keep old scripts happy (fallback)
      const nativeSelect = document.querySelector(`select[name="option-${group.dataset.optionName.toLowerCase().replace(' ', '-')}"]`);
      if(nativeSelect) {
         nativeSelect.value = optionVal;
         nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const nativeRadio = document.querySelector(`input[data-option-position="${optionPos}"][value="${optionVal}"]`);
      if(nativeRadio) {
          nativeRadio.checked = true;
          nativeRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // 4. Find the matching variant in our JSON
      const currentOpt1 = document.getElementById('hidden-opt-1')?.value;
      const currentOpt2 = document.getElementById('hidden-opt-2')?.value;
      const currentOpt3 = document.getElementById('hidden-opt-3')?.value;

      const matchedVariant = variantsData.find(v => {
        let match = true;
        if (currentOpt1 && v.option1 !== currentOpt1) match = false;
        if (currentOpt2 && v.option2 !== currentOpt2) match = false;
        if (currentOpt3 && v.option3 !== currentOpt3) match = false;
        return match;
      });

      if (matchedVariant) {
        // Update URL instantly
        const url = new URL(window.location);
        url.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', url);

        // Update the main variant ID input used for Add To Cart
        const mainIdInput = document.querySelector('product-form input[name="id"]');
        if (mainIdInput) {
          mainIdInput.value = matchedVariant.id;
        }

        // Update SKU subtitle instantly
        const skuEl = document.querySelector('[data-variant-sku]');
        if (skuEl && matchedVariant.sku) {
          skuEl.innerHTML = `BY SVADEZI LUXE &middot; SKU: <span class="sku-val">${matchedVariant.sku}</span>`;
        }

        // Dispatch variant change event so that pricing and other elements update dynamically
        matchedVariant.selectedVariant = matchedVariant; // compatibility with variant.selectedVariant
        window.dispatchEvent(new CustomEvent('kt.product.variant.change', {
          detail: matchedVariant
        }));

        // Fetch new document dynamically for stock indicators and quantity breaks
        const productUrl = optionsContainer.closest('[data-product-url]')?.getAttribute('data-product-url') || window.location.pathname;
        fetch(`${productUrl}?variant=${matchedVariant.id}`)
          .then(res => res.text())
          .then(text => {
            const newDoc = new DOMParser().parseFromString(text, 'text/html');
            window.dispatchEvent(new CustomEvent('kt.product.variant.change.newDoc', {
              detail: newDoc
            }));
          })
          .catch(err => console.error("Error fetching product variant doc:", err));

        // --- INSTANT IMAGE GALLERY SWAPPING ---
        // If the clicked option was Color/Finish, we trigger a Swiper slide
        if (group.querySelector('.color-swatches')) {
           const mediaGallery = document.querySelector('product-media-gallery');
           if (mediaGallery) {
             const swiperMainEl = mediaGallery.querySelector('.swiper-main');
             if (swiperMainEl && swiperMainEl.swiper) {
               
               // First try: If variant has a featured image from Shopify, use its position
               if (matchedVariant.featured_image && matchedVariant.featured_media) {
                 swiperMainEl.swiper.slideTo(matchedVariant.featured_media.position - 1);
               } 
               else {
                 // Fallback: search images by keyword
                 const valLower = optionVal.toLowerCase();
                 let keyword = 'yellow';
                 if (valLower.includes('rose')) keyword = 'rose';
                 if (valLower.includes('white') || valLower.includes('rhodium')) keyword = 'white';

                 const slides = Array.from(swiperMainEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate) img'));
                 let targetImg = slides.find(img => {
                    const src = (img.src || '').toLowerCase();
                    const alt = (img.alt || '').toLowerCase();
                    if (keyword === 'yellow') return src.includes('yellow') || alt.includes('yellow') || src.includes('-yg') || src.includes('_yg');
                    if (keyword === 'rose') return src.includes('rose') || alt.includes('rose') || src.includes('-rg') || src.includes('_rg');
                    if (keyword === 'white') return src.includes('white') || src.includes('rhodium') || alt.includes('white') || alt.includes('rhodium') || src.includes('-wg');
                    return false;
                 });
                 if (!targetImg && keyword === 'yellow' && slides.length > 0) targetImg = slides[0];
                 
                 if (targetImg) {
                    const slide = targetImg.closest('.swiper-slide');
                    const allRealSlides = Array.from(slide.parentNode.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
                    const slideIndex = allRealSlides.indexOf(slide);
                    if (slideIndex !== -1) {
                      swiperMainEl.swiper.slideTo(slideIndex);
                    }
                 }
               }
             }
           }
        }

        // --- INSTANT SPEC TILE UPDATING ---
        const metalTile = document.querySelector('[data-spec-metal]');
        if (metalTile) {
            let p = (currentOpt1 || '').replace(/Gold/gi, '').replace(/Sterling/gi, '').replace(/Silver/gi, '').trim();
            let c = (currentOpt2 || '').replace(/Gold/gi, '').trim();
            metalTile.innerHTML = c ? `${p} &middot; ${c}` : p;
        }
        
        const stoneTile = document.querySelector('[data-spec-stone]');
        if (stoneTile) {
            let stoneText = currentOpt3 || 'Lab Grown';
            if (stoneText.toLowerCase().includes('natural')) stoneText = 'Natural';
            else if (stoneText.toLowerCase().includes('lab') || stoneText.toLowerCase().includes('grown')) stoneText = 'Lab Grown';
            else if (stoneText.toLowerCase().includes('moissanite')) stoneText = 'Moissanite';
            stoneTile.textContent = stoneText;
        }
      }
    });

    // Keyboard Operability (Enter/Space on swatches and other custom elements)
    el.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        el.click();
      }
    });
  });

  // --- WISHLIST DOCK WITH LOCAL STORAGE ---
  const wishlistBtn = document.querySelector('[data-wishlist-toggle]');
  if (wishlistBtn) {
    const handle = wishlistBtn.getAttribute('data-wishlist-toggle');
    console.log("Wishlist button found for handle:", handle);
    
    // Read localstorage on load
    let wishlist = [];
    try {
      wishlist = JSON.parse(localStorage.getItem('svadezi_wishlist') || '[]');
    } catch(e) {}
    
    if (wishlist.includes(handle)) {
      wishlistBtn.classList.add('active');
      wishlistBtn.setAttribute('aria-pressed', 'true');
    }
    
    wishlistBtn.addEventListener('click', () => {
      console.log("Wishlist button clicked!");
      let currentWishlist = [];
      try {
        currentWishlist = JSON.parse(localStorage.getItem('svadezi_wishlist') || '[]');
      } catch(e) {}
      
      if (wishlistBtn.classList.contains('active')) {
        wishlistBtn.classList.remove('active');
        wishlistBtn.setAttribute('aria-pressed', 'false');
        currentWishlist = currentWishlist.filter(item => item !== handle);
      } else {
        wishlistBtn.classList.add('active');
        wishlistBtn.setAttribute('aria-pressed', 'true');
        if (!currentWishlist.includes(handle)) {
          currentWishlist.push(handle);
        }
      }
      
      localStorage.setItem('svadezi_wishlist', JSON.stringify(currentWishlist));
    });
  }

  // --- PRICING CARD ACCORDION TOGGLE ---
  const pricingHeader = document.querySelector('.pricing-card-header');
  if (pricingHeader) {
    console.log("Pricing header found!");
    pricingHeader.addEventListener('click', () => {
      console.log("Pricing header clicked!");
      const card = pricingHeader.closest('.pricing-card');
      const body = card.querySelector('.pricing-card-body') || pricingHeader.nextElementSibling;
      const isExpanded = pricingHeader.getAttribute('aria-expanded') === 'true';
      
      if (body) {
        if (isExpanded) {
          body.style.display = 'none';
          pricingHeader.setAttribute('aria-expanded', 'false');
          pricingHeader.classList.add('collapsed');
        } else {
          body.style.display = 'block';
          pricingHeader.setAttribute('aria-expanded', 'true');
          pricingHeader.classList.remove('collapsed');
        }
      }
    });
    
    pricingHeader.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        pricingHeader.click();
      }
    });
  }

  // --- ACCORDIONS GROUP TOGGLE ---
  const accordionHeaders = document.querySelectorAll('.accordion-group .accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const body = header.nextElementSibling;
      if (!body) return;
      
      const isOpen = body.classList.contains('open');
      if (isOpen) {
        body.classList.remove('open');
        header.setAttribute('aria-expanded', 'false');
      } else {
        body.classList.add('open');
        header.setAttribute('aria-expanded', 'true');
      }
    });
    
    header.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        header.click();
      }
    });
  });

  // --- MOBILE STICKY CTA SUBSCRIBER ---
  window.addEventListener('svadezi:price-updated', (event) => {
    if (event.detail) {
      const { current, compareAt, save, savePct, emi } = event.detail;
      const formatter = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      
      const priceEl = document.querySelector('.mobile-sticky-cta [data-mobile-price]');
      const savingsEl = document.querySelector('.mobile-sticky-cta [data-mobile-savings]');
      const emiEl = document.querySelector('.mobile-sticky-cta [data-mobile-emi]');
      
      if (priceEl) priceEl.textContent = formatter.format(current);
      if (savingsEl) {
        if (save > 0) {
          savingsEl.textContent = `${formatter.format(save)} off · ${savePct}% saved`;
          savingsEl.style.display = 'block';
        } else {
          savingsEl.style.display = 'none';
        }
      }
      if (emiEl) emiEl.textContent = `EMI from ${formatter.format(emi)}/mo`;
    }
  });

  // --- MOBILE STICKY WISHLIST SYNC ---
  function syncWishlistStates() {
    const mainWishlist = document.querySelector('.info-col .btn-wishlist');
    const stickyWishlist = document.querySelector('.mobile-sticky-cta .btn-wishlist');
    if (mainWishlist && stickyWishlist) {
      if (mainWishlist.classList.contains('active')) {
        stickyWishlist.classList.add('active');
        stickyWishlist.setAttribute('aria-pressed', 'true');
      } else {
        stickyWishlist.classList.remove('active');
        stickyWishlist.setAttribute('aria-pressed', 'false');
      }
    }
  }

  const stickyWishlistBtn = document.querySelector('.mobile-sticky-cta .btn-wishlist');
  const mainWishlist = document.querySelector('.info-col .btn-wishlist');
  
  if (stickyWishlistBtn && mainWishlist) {
    stickyWishlistBtn.addEventListener('click', () => {
      mainWishlist.click();
      syncWishlistStates();
    });
    
    mainWishlist.addEventListener('click', () => {
      setTimeout(syncWishlistStates, 0);
    });
    
    // Initial sync
    syncWishlistStates();
  }
});

